export default {
  "config": {
    "trial": "tones-3",
    "id": "ae-incidence-nausea",
    "type": "bar",
    "title": "Incidence of New or Increased Severity TEAEs: Nausea<sup>7,19,27</sup><sup>,a,b</sup>",
    "xAxis": {
      "groups": [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
      ],
      "padding": 0.1,
      "label": {
        "text": "Week"
      },
      "shadedRegion": [],
      "scale": "scaleBand",
      "hideZeroValues": true,
    },
    "yAxis": {
      "low": 0,
      "high": 10,
      "inc": 1,
      "label": {
        "text": [
          "<no-break>Participants, %</no-break>"
        ]
      }
    },
    "legend": [
      {
        "entry": "pbo",
        "label": "Placebo",
        "color": "#868686",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Placebo"
      },
      {
        "entry": "sol-375",
        "label": "Solriamfetol 37.5 mg",
        "color": "#006e8a",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 37.5 mg"
      },
      {
        "entry": "sol-75",
        "label": "Solriamfetol 75 mg",
        "color": "#ffce00",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 75 mg"
      },
      {
        "entry": "sol-150",
        "label": "Solriamfetol 150 mg",
        "color": "#73cac3",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 150 mg"
      },
      {
        "entry": "sol-300",
        "label": "Solriamfetol 300 mg",
        "color": "#be5b92",
        "line": "solid",
        "shape": "dot",
        "tooltip": "Solriamfetol 300 mg"
      }
    ],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is <no-break>150 mg.<sup>27</sup></no-break>",
      "<sup>a</sup>Common early-onset TEAEs were defined as those occurring in <no-break>≥5%</no-break> of participants in any solriamfetol dose group and greater than placebo during <no-break>week 1.</no-break> Common early-onset TEAEs were decreased appetite, headache, anxiety, nausea, feeling jittery, and insomnia.",
      "<sup>b</sup>For TEAEs identified during week 1, incidence of new occurrence or increase in severity over time was calculated for each subsequent study week."
    ],
    "useFootnoteTooltip": true,
    "trendLines": [],
    "chartLegend": [
      {
        "active": true,
        "entries": [
          {
            "entry": "pbo",
            "label": "Placebo",
            "color": "#868686",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Placebo"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-375",
            "label": "Solriamfetol 37.5 mg",
            "color": "#006e8a",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 37.5 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-75",
            "label": "Solriamfetol 75 mg",
            "color": "#ffce00",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 75 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-150",
            "label": "Solriamfetol 150 mg",
            "color": "#73cac3",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 150 mg"
          }
        ]
      },
      {
        "active": true,
        "entries": [
          {
            "entry": "sol-300",
            "label": "Solriamfetol 300 mg",
            "color": "#be5b92",
            "line": "solid",
            "shape": "dot",
            "tooltip": "Solriamfetol 300 mg"
          }
        ]
      }
    ]
  },
  "data": [
    {
      "x": 1,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 1.7,
          "label": {
            "text": 1.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 3.5,
          "label": {
            "text": 3.5,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 1.6,
          "label": {
            "text": 1.6,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 2.6,
          "label": {
            "text": 2.6,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 5.9,
          "label": {
            "text": 5.9,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 2,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 1.6,
          "label": {
            "text": 1.6,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 1.7,
          "label": {
            "text": 1.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 5.1,
          "label": {
            "text": 5.1,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 3,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 1.7,
          "label": {
            "text": 1.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 1.8,
          "label": {
            "text": 1.8,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 4,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 1.7,
          "label": {
            "text": 1.7,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 2.6,
          "label": {
            "text": 2.6,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 5,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 6,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 7,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 8,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 9,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 10,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 11,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": 12,
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 0.9,
          "label": {
            "text": 0.9,
            "sup": "",
            "override": ""
          }
        },
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 0,
          "label": {
            "text": 0,
            "sup": "",
            "override": ""
          }
        }
      ]
    }
  ]
};
